import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from './modal.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private dialog: MatDialog) {}

  open(component: any, options: {
    title?: string;
    componentData?: any;
    actions?: { label: string; closeOnClick?: boolean; returnValue?: any }[];
    width?: string;
    height?: string;
  }) {
    return this.dialog.open(ModalComponent, {
      width: options.width || '500px',
      height: options.height,
      data: {
        title: options.title,
        component,
        componentData: options.componentData,
        actions: options.actions || [{ label: 'Close', closeOnClick: true }],
      },
    });
  }
}
